import { formatQueryRange } from '../utils/common';
import { removeFalseyParams } from '../utils/queryParams';
import { handleApiCalls } from './axiosInstance';
import BaseAPI from './baseAPI';

class TripAnomaliesAPI extends BaseAPI {
  constructor() {
    super({ suffix: 'trip-anomalies' });
  }

  /**
   * @param {object} filters
   * @param {string} filters.userId
   * @param {string} filters.companyId
   * @param {"gps-litter" | "high-speed"} filters.type
   * @param {string} filters.fromDate
   * @param {string} filters.toDate
   */
  fetchTripAnomalies = async (filters = {}, pageNumber, pageSize) => {
    const params = removeFalseyParams(filters);
    const range = formatQueryRange(pageNumber, pageSize);
    const response = await handleApiCalls('get', this.baseUrl, {
      params: { ...params, range },
    });
    return response.data;
  };

  /**
   * @param {string} anomalyId
   */
  fetchTripAnomalyDetails = async anomalyId => {
    const response = await handleApiCalls('get', this.baseUrl + `/${anomalyId}`);

    return response.data;
  };

  /**

   * @param {{ anomalyId: string, action: 'accept' | 'reject', modifyTrip?: boolean, note?: string}} reviewAnomalyParameters 
   */
  reviewTripAnomaly = async ({ anomalyId, action, modifyTrip, note }) => {
    const response = await handleApiCalls('patch', this.baseUrl + `/${anomalyId}/review`, {
      action,
      ...(modifyTrip !== null && { modifyTrip }),
      ...(note && { note }),
    });
    return response.data;
  };
}

export default TripAnomaliesAPI;
